import React, {Component} from 'react';
import './Organizers.scss'
import Organizer from "../Components/Organizer";
import {speakLoud} from "./OrganizerList";

class Organizers extends Component {

    render() {
        return (
            <div className="wtm-organizers">
                <h1>ORGANIZERS</h1>
                <div className="list">
                    {
                        speakLoud.map(organizer => (<Organizer organizer={organizer}/>
                        ))
                    }
                </div>
            </div>
        );
    }
}

export default Organizers;
